import type { Module } from '@/types/modules';

/**
 * Find all modules matching an object type, returning the id/label of each match.
 */
export function findModulesByObjectType(
  availableModules: Module[],
  objectType: string,
): Array<{ id: string; label: string }> {
  if (availableModules.length === 0) return [];
  return availableModules
    .filter(m => m.objectType === objectType)
    .map(m => ({ id: m.id, label: m.label }));
}
